export const getSession = (key: string): string | null => {
  return sessionStorage.getItem(key);
};

export const setSession = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

export const clearSession = () => {
  sessionStorage.clear();
};

export const isUserLoggedIn = (): boolean | null => {
  return sessionStorage.getItem('isLoggedIn') == 'true';
};

export const PLP_RESET_AFTER_LOGIN_KEY = 'plpResetAfterLogin';
export const PERSONALIZED_ALERT_AUTO_OPEN_KEY = 'personalizedAlertShouldAutoOpen';
export const PERSONALIZED_ALERT_AUTO_OPEN_ROUTE_KEY = 'personalizedAlertAutoOpenRoute';
export const PERSONALIZED_ALERT_DISMISSED_KEY = 'personalizedAlertDismissed';

export const clearPersonalizedAlertStorage = () => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(PERSONALIZED_ALERT_AUTO_OPEN_KEY);
  sessionStorage.removeItem(PERSONALIZED_ALERT_AUTO_OPEN_ROUTE_KEY);
  sessionStorage.removeItem(PERSONALIZED_ALERT_DISMISSED_KEY);
  sessionStorage.removeItem('suppressRxModalOnce');
};

export const setPersonalizedAlertAutoOpenRoute = (route: string) => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(PERSONALIZED_ALERT_AUTO_OPEN_ROUTE_KEY, route);
};

export const setPlpResetAfterLogin = () => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(PLP_RESET_AFTER_LOGIN_KEY, 'true');
};

export const isPlpResetAfterLoginPending = (): boolean => {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(PLP_RESET_AFTER_LOGIN_KEY) === 'true';
};

export const clearPlpResetAfterLogin = () => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(PLP_RESET_AFTER_LOGIN_KEY);
};
